import React from 'react';
import ReactDOM from 'react-dom';

class CartItem extends React.Component {

    handleCartClickIncreement = (id,custom,cartCount)=>{

        let cartTotalCount = 0;
        cartCount = cartCount + 1;
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        Object.keys(cartData).forEach(function(key) {
            //console.log(key);
            //console.log(cartData[key]);
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id)
            {
                cartTotalCount += cartData[key];
            }

            if(cart_id[0]==id && custom==cart_id[1])
            {
                cartData[key] = cartCount;
            }
        });
        cartTotalCount += 1;

        localStorage.setItem('cartData', JSON.stringify(cartData));
        this.props.updateCart2();
    }

    handleCartClickDecreement = (id,custom,cartCount)=>{
        
        cartCount = (cartCount!=0)?cartCount - 1:0;
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        Object.keys(cartData).forEach(function(key) {
            //console.log(key);
            //console.log(cartData[key]);
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id && custom==cart_id[1])
            {
                if(cartCount==0)
                    delete cartData[key];
                else
                    cartData[key] = cartCount;
            }
        });

        localStorage.setItem('cartData', JSON.stringify(cartData));
        cart = localStorage.getItem('cartData');
        if(cart === null || cart ==='{}')
        {
            localStorage.removeItem('cartRES');
            localStorage.removeItem('cartInstructions');
            localStorage.removeItem("cartData");
            localStorage.removeItem('cartVendorID');
            localStorage.removeItem('cartVendorName');
            localStorage.removeItem('cartVendorTypeID');
        }
        
        /*if(cart === null || cart ==='{}')
        {
            localStorage.removeItem('cartRES');
            localStorage.removeItem('cartData');
            localStorage.removeItem('cartInstructions');
            localStorage.removeItem("cartData");
        }
        else
            localStorage.setItem('cartData', JSON.stringify(cartData));*/

        this.props.updateCart2();
    }

    //const CartItem = (props) => {
    render() {

        //console.log(this.props);
        return (
            this.props.item.map((item, i)=>{
                if(this.props.itemID==item.ITEMID)
                {
                    let itemTOTAL = 0;
                    let itemRATE = item.RATE;
                    let itemCOUNT = this.props.itemCOUNT;
                    let itemCUSTOM = this.props.itemCUSTOM;
                    let customLIST = '';
                    
                    if(itemCUSTOM!='N' && itemCUSTOM!='')
                    {
                        let custom = itemCUSTOM.split('|');
                        //console.log(custom);
                        if(custom!='')
                        {
                            custom.forEach(val => { 
                                let val2 = val.split('~');
                                itemRATE = parseFloat(itemRATE) + parseFloat(val2[3]);

                                item.CUSTOM.map(addon=>{

                                        if(addon.CUSTOMID==val2[0])
                                        {
                                            addon.DET.map(addon2=>{
                                                if(addon2.CUSTOMDATID==val2[1])
                                                    customLIST += addon2.CUSTOMDATNAME+', ';
                                            })
                                        }   
                                    })

                            });
                        }
                    }

                    if(customLIST!='')
                        customLIST = customLIST.substring(0, customLIST.length-2)

                    itemTOTAL = itemCOUNT * itemRATE;

                    return(
                        //console.log(item.ITEMID+' == '+itemID);
                        <li key={item.ITEMID}>
                            <div className="row full" style={{width: '100%'}}>
                                <div className="veggann">
                                    <img src={`assets/img/${item.TYPE}.svg`} alt={item.TYPE} />
                                </div>
                                <div className="col-6" >
                                    <p>{item.ITEMNAME}</p>
                                    {customLIST && <p className="addi">Added: {customLIST}</p>}
                                    <p className="actual-prize">&#8377; {itemRATE}</p>
                                </div>
                                <div className="col-3" >
                                    <div className="aditions" >
                                        <div className="openned">
                                            <button onClick={()=>{this.handleCartClickDecreement(item.ITEMID,itemCUSTOM,itemCOUNT)}}> - </button>
                                                <input type="text" className="round-circle" value={itemCOUNT} readOnly />
                                            <button onClick={()=>{this.handleCartClickIncreement(item.ITEMID,itemCUSTOM,itemCOUNT)}}> + </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3 prize">&#8377; {itemTOTAL}</div>
                            </div>
                        </li>
                    );
                }
            })
        );
    }
}
  
export default CartItem;


// WEBPACK FOOTER //
// ./src/components/CartItem.js